// extracted by css-extract-rspack-plugin
export default {"filtersFormOrderBy":"filters-form-order-by--mQiKTkSDrsIakwos","filtersFormDummy":"filters-form-dummy--lCRm3hf019s8Pi5a"};